import { createSelector } from 'reselect';
import { performanceChartNavSelector } from '.';

/**
 * @returns {( object ) => object|null} Round.
 */
export const roundSelector = createSelector(
    performanceChartNavSelector,
    (state) => state.round
);
